import { render, staticRenderFns } from "./LookUser.vue?vue&type=template&id=0c8e316d&scoped=true"
import script from "./LookUser.vue?vue&type=script&lang=js"
export * from "./LookUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e316d",
  null
  
)

export default component.exports